export default "__VITE_ASSET__P_yQR5nN__"